import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './RequestDto';

type TPayload = {
    token?: string,
    detailType?: 'basic' | 'full',
    request?: RequestDto,
}

/**
 * Получение списка договоров
 *
 * {@link https://master.core-profile.sandbox.d2c.r-one.io/docs#/User%20agreements/UserAgreementsV2Controller_get Documentation}
 */
export const agreements = ({ token, request, detailType }: TPayload = {}): IRequest => {
    const headers: Record<string, string> = {};

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (request) {
        headers.domain = request.domain;
    }

    return {
        uri: `v2/user/agreements?detailType=${detailType ?? 'basic'}`,
        method: 'GET',
        withAuth: true,
        withProvider: true,
        ...(Object.entries(headers).length > 0 && { headers }),
    };
};

export type { RequestDto };
export type { ResponseDto, UserAgreementDto } from './ResponseDto';
